const DAY_MS = 24 * 60 * 60 * 1000;

function localCalendarDate(isoDate: string): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoDate);
  if (!match) return null;
  const [, yearText, monthText, dayText] = match;
  const year = Number(yearText);
  const month = Number(monthText);
  const day = Number(dayText);
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null;
}

export function daysUntilExpiry(expiry?: string, now = new Date()): number | null {
  if (!expiry) return null;
  const expiryDate = localCalendarDate(expiry);
  if (!expiryDate) return null;
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((expiryDate.getTime() - today.getTime()) / DAY_MS);
}

export type ExpiryStatus = 'expired' | 'expiring' | 'current' | 'missing';

export function expiryStatus(expiry?: string, now = new Date()): ExpiryStatus {
  const days = daysUntilExpiry(expiry, now);
  if (days === null) return 'missing';
  if (days < 0) return 'expired';
  if (days <= 30) return 'expiring';
  return 'current';
}
